<template>
    <div class="d-flex flex-column">
        <div class="d-flex pa-2 flex-row justify-space-between align-center">
            <div>{{ t_amount }}:</div>
            <div class="d-flex flex-row">
                <span class="radio-label mr-2" @click.stop.prevent="filterAmount('top50')">
                    <i :class="[amount === 'top50' ? 'fa-solid' : 'fa-regular','fa-circle']"/>&nbsp;{{t_amount_top50}}
                </span>
                <span class="radio-label" @click.stop.prevent="filterAmount('top10')">
                    <i :class="[amount === 'top10' ? 'fa-solid' : 'fa-regular','fa-circle']"/>&nbsp;{{t_amount_top10}}
                </span>
            </div>
        </div>
        <div class="d-flex pa-2 flex-row justify-center align-center">
            <v-text-field
                :label="t_search"
                :value="search"
                dense
                hide-details
                outlined
                @input="$emit('update:search', $event)"
                style="background-color: white"/>
        </div>
        <div class="d-flex pa-2 flex-row justify-center align-center">
            <datepicker
                :label="t_date_from"
                :max="to || dateNowUS"
                :placeholder="from ? undefined : t_placeholder_subOneWeek"
                :value="from"
                hideDetails
                @input="$emit('update:from', $event)"
            />
        </div>
        <div class="d-flex pa-2 flex-row justify-center align-center">
            <datepicker
                :label="t_date_to"
                :max="dateNowUS"
                :min="from"
                :placeholder="to ? undefined : t_placeholder_now"
                :value="to"
                hideDetails
                @input="$emit('update:to', $event)"
            />
        </div>
        <div class="d-flex pa-2 flex-row justify-center align-center">
            <v-btn type="button" class="btn btn-w-m btn-primary" @click.stop.prevent="handleClick" :disabled="loading">
                <i v-if="loading" class="fa-regular fa-spinner fa-spin-pulse m-r-xs"></i>
                {{ t_filter }}
            </v-btn>
        </div>
    </div>
</template>
<script>
import { dateISOToDateUS, dateTodayUS, dateUSToDateISO, localizeDate } from '../../../utils/date'

    export default {
        props: {
            /** @type {DateUS} From date in US American date format (MM/dd/yyyy) */
            from: String,
            /** @type {DateUS} To date in US American date format (MM/dd/yyyy) */
            to: String,
            search: String,
            amount: String,
            loading: Boolean
        },
        data() {
            return {
                t_all: Lang.langGet("All Clients incl. removed"),
                t_date_from: Lang.langGet("Show data from"),
                t_date_to: Lang.langGet("Show data until"),
                t_filter: Lang.langGet("Apply filter"),
                t_amount: Lang.langGet("Limit data"),
                t_amount_top50: Lang.langGet("Top 50"),
                t_amount_top10: Lang.langGet("Top 10"),
                t_search: Lang.langGet("Search"),
            }
        },
        computed: {
            dateNowUS() {
                return dateTodayUS()
            },
            t_placeholder_now() {
                return localizeDate(this.dateNowUS, Laravel.activeDateformat)
            },
            t_placeholder_subOneWeek() {
                const toDate = this.to ? new Date(dateUSToDateISO(this.to)) : new Date()
                const subOneWeekDate = new Date(toDate)
                subOneWeekDate.setDate(subOneWeekDate.getDate() - 7)
                return localizeDate(dateISOToDateUS(subOneWeekDate.toISOString().substring(0, 10)), Laravel.activeDateformat)
            }
        },
        methods: {
            filterAmount(type) {
                this.$emit('update:amount', type)
            },
            handleClick() {
                if(this.loading) { return; }

                this.$emit('applyFilter');
            }
        },
    }
</script>
